export default {
  getAllProducts: 'product',
  validateCart: 'order/preOrder',
  addToWaitingList: 'waitlist',
  realizeOrder: 'order',
  calculateDiscount: 'discount/amount',
  agreement: 'agreement'
}
